import Vue from 'vue'

Vue.prototype.$backgroundRowTable = function (index, primary = 'rgb(255 210 174 / 58%)', secondary = 'rgb(255 232 213 / 58%)') {
  const colorRow = index % 2 === 0 ? primary : secondary
  return colorRow
}
